var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return Boolean(_vm.quoteMessage) && _vm.props.displayType !== 'audio' ? _c('div', {
    class: {
      'input-quote-container': true,
      'input-quote-container-h5': _vm.isH5
    }
  }, [_c('div', {
    class: !_vm.isPC ? 'input-quote-content-h5' : 'input-quote-content'
  }, [_vm.isPC ? _c('div', {
    staticClass: "max-one-line"
  }, [_vm._v(" " + _vm._s((_vm.quoteMessage.nick || _vm.quoteMessage.from) + ': ' + _vm.quoteContentText) + " ")]) : _c('div', {
    staticClass: "input-quote-message-h5 max-one-line"
  }, [_c('div', {
    staticClass: "input-quote-sender-h5"
  }, [_vm._v(" " + _vm._s(_vm.quoteMessage.nick || _vm.quoteMessage.from) + " ")]), _c('div', {
    staticClass: "max-one-line"
  }, [_vm._v(" " + _vm._s(_vm.quoteContentText) + " ")])]), _c('Icon', {
    staticClass: "input-quote-close-icon",
    attrs: {
      "file": _vm.closeIcon,
      "width": "14px",
      "height": "14px"
    },
    on: {
      "onClick": _vm.cancelQuote
    }
  })], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }